import React, { memo } from "react";
import { HStack, Text, Highlight } from "@chakra-ui/react";
import colors from "app/colors";
import UserAvatar from "../_shared/user-avatar";
import { UserRoleType } from "gql/graphql";
import { getUserMention } from "modules/utils/Functions";

interface IProps {
  user?: {
    id: string;
    callout?: string | null;
    email?: string | null;
    roleType: UserRoleType;
    active: boolean;
  };
  search: string;
}

const SelectedUserOption = ({ user, search }: IProps) => {
  if (!user) return null;
  if (user.active) {
    return (
      <HStack color={colors.blue} spacing={1}>
        <UserAvatar
          userId={user.id}
          size="2xs"
          displayOnlineIndicator={false}
        />
        <Text noOfLines={1} fontSize={14}>
          <Highlight
            query={search}
            styles={{
              fontWeight: 700,
              color: colors.blue,
              margin: "0 !important",
            }}
          >
            {getUserMention(user)}
          </Highlight>
        </Text>
      </HStack>
    );
  }
  return (
    <HStack color={colors.grayMain} spacing={1}>
      <UserAvatar userId={user.id} size="2xs" displayOnlineIndicator={false} />
      <Text noOfLines={1} fontSize={14}>
        <Highlight
          query={search}
          styles={{
            fontWeight: 700,
            color: colors.blue,
            margin: "0 !important",
          }}
        >
          {getUserMention(user)}
        </Highlight>
      </Text>
    </HStack>
  );
};

export default memo(SelectedUserOption);
